import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { Link as MUILink } from '@mui/material';
import classnames from 'classnames';

const MaterialLink = (props) => {
  const { href, className, children, underline = 'always', routerLink = false, name } = props;

  return routerLink ? (
    <Link className={classnames(MaterialLink.displayName, className)} to={href} data-testid={`${name}-link`}>
      {children}
    </Link>
  ) : (
    <MUILink
      {...props}
      className={classnames(MaterialLink.displayName, className)}
      underline={underline}
      href={href}
      data-testid={`${name}-muiLink`}
    >
      {children}
    </MUILink>
  );
};

MaterialLink.displayName = 'MaterialLink';

MaterialLink.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  underline: PropTypes.string,
  routerLink: PropTypes.bool,
  name: PropTypes.string,
};

export default React.memo(MaterialLink);
